import { StudyMode } from '@/store';

import { ADDENDUM_FIELD_POLICY } from '../constant';
import type {
  AddendumFieldCapability,
  AddendumFieldCapabilityResult,
  AddendumFieldId,
} from '../model';

interface ResolveAddendumFieldCapabilityParams {
  fieldId: AddendumFieldId;
  studyMode: null | StudyMode;
}

function resolveCapability({
  fieldId,
  studyMode,
}: ResolveAddendumFieldCapabilityParams): AddendumFieldCapability {
  if (studyMode === 'read-only') {
    return 'disabled';
  }

  if (studyMode === 'addendum') {
    return ADDENDUM_FIELD_POLICY[fieldId];
  }

  return 'editable';
}

export function resolveAddendumFieldCapability({
  fieldId,
  studyMode,
}: ResolveAddendumFieldCapabilityParams): AddendumFieldCapabilityResult {
  const capability = resolveCapability({ fieldId, studyMode });

  return {
    capability,
    isDisabled: capability === 'disabled',
    isEditable: capability === 'editable',
  };
}
